import { handleAction } from 'redux-actions';

import * as Actions from 'flex/Actions';

const defaultState = {
    payload: {},
    meta: {
        fetch: false,
        status: '',
        viewName: '',
    },
};

const defaultReducer = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    next: (_: any, action: any) => {
        return { ...action };
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    throw: (_: any, action: any) => {
        return Object.assign(action, {
            meta: {
                fetch: false,
                status: Actions.statusEnum.FAILURE,
            },
        });
    },
};

export const tenantNewTermSchoolClassSettingViewConnection = handleAction(
    Actions.http.connection.tenantNewTermSchoolClassSetting.view,
    defaultReducer,
    defaultState
);

export const tenantNewTermSchoolClassSettingControlSaveConnection = handleAction(
    Actions.http.connection.tenantNewTermSchoolClassSetting.controlSave,
    defaultReducer,
    defaultState
);

export const tenantNewTermSchoolClassSettingControlViewConnection = handleAction(
    Actions.http.connection.tenantNewTermSchoolClassSetting.controlView,
    defaultReducer,
    defaultState
);

export const newTermSchoolClassSettingViewConnection = handleAction(
    Actions.http.connection.newTermSchoolClassSetting.view,
    defaultReducer,
    defaultState
);
export const newTermSchoolClassSettingSaveConnection = handleAction(
    Actions.http.connection.newTermSchoolClassSetting.save,
    defaultReducer,
    defaultState
);
